import { render } from "./LndContacts.vue?vue&type=template&id=13ccf28d&lang=pug"
import script from "./LndContacts.vue?vue&type=script&lang=js"
export * from "./LndContacts.vue?vue&type=script&lang=js"

import "./LndContacts.vue?vue&type=style&index=0&id=13ccf28d&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__